// extracted by mini-css-extract-plugin
export default {"price":"s6-z","onSale":"t6-z","msrpLabelPrice":"u6-z","msrpLabel":"v6-z","originalPrice":"w6-z","percentOff":"x6-z"};